var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('h2',[_vm._v("Статистика")]),_vm._v(" "),_c('back'),_vm._v(" "),_c('div',{staticClass:"game game--stat"},[_c('StatBody',{attrs:{"student":_vm.user}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }